import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeDetailsComponent } from './employee-details.component';
import { SharedModule } from '../../../core/shared/shared.module';
import { EmployeeDetailsRouting } from './employee-details.routing';
import { CustomerSelectionComponent } from '../customer-selection/customer-selection.component';
import { CustomersRest } from '../../customers/customers.rest';
import { EmployeeDetailsHeaderComponent } from './header/employee-details-header.component';
import { IssuesRest } from '../../../issues/issues.rest';
import { UserDetailsRest } from '../../users/user-details/user-details.rest';
import { AbsencesCalendarModule } from '../../../absences/absences-calendar/absences-calendar.module';
import { EmployeeSignatureModalComponent } from './employee-signature-modal/employee-signature-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EmployeeDetailsRouting,
    AbsencesCalendarModule
  ],
  declarations: [EmployeeDetailsComponent, CustomerSelectionComponent, EmployeeDetailsHeaderComponent, EmployeeSignatureModalComponent],
  providers: [CustomersRest, IssuesRest, UserDetailsRest]
})
export class EmployeeDetailsModule { }
